'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scopeAppropriateImage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSimpleSurveyor = require('@mapbox/react-simple-surveyor');

var _reactSimpleSurveyor2 = _interopRequireDefault(_reactSimpleSurveyor);

var _appropriateImagesGetUrl = require('@mapbox/appropriate-images-get-url');

var _appropriateImagesGetUrl2 = _interopRequireDefault(_appropriateImagesGetUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function scopeAppropriateImage(imageConfig, options) {
  options = options || {};
  var transformUrl = options.transformUrl !== undefined ? options.transformUrl : function (x) {
    return x;
  };
  var hiResRatio = options.hiResRatio !== undefined ? options.hiResRatio : 1.3;

  var AppropriateImage = function (_React$PureComponent) {
    _inherits(AppropriateImage, _React$PureComponent);

    function AppropriateImage() {
      _classCallCheck(this, AppropriateImage);

      return _possibleConstructorReturn(this, (AppropriateImage.__proto__ || Object.getPrototypeOf(AppropriateImage)).apply(this, arguments));
    }

    _createClass(AppropriateImage, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var url = (0, _appropriateImagesGetUrl2.default)({
          imageId: this.props.imageId,
          availableWidth: this.props.width,
          imageConfig: imageConfig,
          hiResRatio: hiResRatio
        });
        url = transformUrl(url);

        var elementProps = Object.keys(this.props).reduce(function (result, key) {
          // All prop types we don't want to pass to the element should fail this condition.
          if (!/^(imageId|width|background|backgroundPosition|backgroundSize)$/.test(key)) {
            result[key] = _this2.props[key];
          }
          return result;
        }, {});

        if (!this.props.background) {
          return _react2.default.createElement('img', _extends({ src: url }, elementProps));
        }

        var backgroundStyle = {
          backgroundImage: 'url("' + url + '")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: this.props.backgroundPosition,
          backgroundSize: this.props.backgroundSize,
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };
        if (elementProps.style) {
          Object.keys(elementProps.style).forEach(function (key) {
            backgroundStyle[key] = elementProps.style[key];
          });
          delete elementProps.style;
        }
        return _react2.default.createElement('div', _extends({}, this.props.imageProps, { style: backgroundStyle }));
      }
    }]);

    return AppropriateImage;
  }(_react2.default.PureComponent);

  AppropriateImage.propTypes = {
    imageId: _propTypes2.default.string.isRequired,
    background: _propTypes2.default.bool,
    backgroundPosition: _propTypes2.default.string,
    backgroundSize: _propTypes2.default.string,
    // Provided by survey
    width: _propTypes2.default.number.isRequired
  };

  AppropriateImage.defaultProps = {
    background: false,
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  };

  return (0, _reactSimpleSurveyor2.default)(AppropriateImage);
}

exports.scopeAppropriateImage = scopeAppropriateImage;